import getScreenWidth from '../dom-utils/getScreenWidth';
import { useEffect, useState } from 'react';
import getGlobal from '../shared/getGlobal';

/**
 * 用于监听Resize变化的hook
 * 允许接收一个init函数和一个resize函数，如果都没有传那么就是返回当前的屏幕宽度
 * init函数会被传入当前的getScreenWidth()
 * resize函数会被传入当前的state、setStaste、getScreenWidth()
 */

type IResize<T> = (options: {state: T | number; setState: React.Dispatch<React.SetStateAction< T | number>>; currentWidth: number;}) => void;
type IInit<T> = (currentWidth: number) => T | number;
export default function useScreenWidth<T>({init, resize}: {init?: IInit<T>; resize?: IResize<T>;} = {}): T | number {

    const [ state, setState ] = useState<T | number>(init ? init(getScreenWidth()) : getScreenWidth());

    useEffect(() => {

        const onResize = (): void => {
            if(resize) {
                resize({state, setState, currentWidth: getScreenWidth()});
            }
            else {
                setState(getScreenWidth());
            }
        };

        window.addEventListener('resize', onResize);

        return () => {

            getGlobal().removeEventListener('resize', onResize);
        };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return state;
}
